<template>
  <div style="text-align: center;">

    <template v-if="wishBetMsg.data.type === 'message'">
      <div class="dialog_text">
        <p v-html="wishBetMsg.data.content"></p>
      </div>
      <button class="v-btn primary-btn" style="margin-left: 0px" @click="closeDialog()">
        <span >{{ $t('WishBets.CloseDialog') }}</span>
      </button>
    </template>

    <template v-if="wishBetMsg.data.type === 'barcode'">
      <div class="dialog_header">
        <span class="header_text">{{ $t('WishBet.BarcodeInfo') }}</span>
        <v-icon class="close" @click="closeBarCodeDialog()">close</v-icon>
      </div>
      <div class="dialog_text">
        <vue-barcode :value="wishBetMsg.data.content" format="ITF14"></vue-barcode>
      </div>
    </template>

    <template v-if="wishBetMsg.data.type === 'confirmation_popup'">
      <div class="dialog_text">
        <p v-html="$t('WishBet.DeleteBetDesc')"></p>
      </div>
      <button class="v-btn secondary-btn" style="margin-left: 0px" @click="closeDialog()">
        <span >{{ $t('WishBets.No') }}</span>
      </button>
      <button class="v-btn primary-btn" style="margin-left: 0px" @click="deleteWishBet()">
        <span >{{ $t('WishBets.Yes') }}</span>
      </button>
    </template>

    <template v-if="wishBetMsg.data.type === 'checkbet'">
      <div class="dialog_header">
        <h3>{{ $t('WishBet.TicketInfo')}}</h3>
        <v-icon class="close" @click="closeDialog()">close</v-icon>
      </div>
      <div v-if="scannedTicketError" class="dialog_text error_msg">
        <span> {{scannedTicketError}} </span>
      </div>
      <div v-if="!scannedTicketError" class="dialog_text">
        <div class="ticket_status" :class="ticketStatusFormated">
          {{ $t('WishBet.TicketInfo.Status' + ticketStatusFormated) }}
        </div>
        <h3 v-if="scannedTicket.payoutAmount && ticketStatusFormated === 'Unpaid'" class="payout_amount">
          {{ $t('WishBet.TicketInfo.PayoutAmount') }} 
          <span class="amount"> {{scannedTicket.currency}} {{ payoutAmountFormated }}</span>
        </h3>
        <div class="ticket_desc">
          {{ $t('WishBet.TicketInfo.Status' + ticketStatusFormated + 'Desc') }}
        </div>
        <div class="ticket_info">
          <span class="line"><span class="label">{{ $t('WishBet.TicketInfo.TicketId') }}</span> #{{scannedTicket.ticketId}}</span>
          <span class="line"><span class="label">{{ $t('WishBet.TicketInfo.Date') }} </span>
            <span>{{scannedTicket.placementTime | moment('MM/DD/YYYY')}}</span>
            <span>{{scannedTicket.placementTime | moment(dateFormats.longTime)}}</span>
          </span>
        </div>
        <!-- {{scannedTicket}} -->
      </div>
      </template>

  </div>
</template>

<script>
  //  import Vue from 'vue'
  import store from '@/store'
  import config from '@/config'
  import VueBarcode from 'vue-barcode'

  export default {
    name: 'wish-bet-msg-dialog',

    data () {
      return {
      }
    },
    components: {
      VueBarcode
    },

    computed: {
      dateFormats () {
        return config.app.dateFormats
      },
      wishBetMsg () {
        return store.getters['overlayState/getWishBetMsgDialogState']
      },
      scannedTicket () {
        return store.getters['wishBets/getTicketInfo']
      },
      scannedTicketError () {
        return store.getters['wishBets/getTicketInfoError']
      },
      ticketStatusFormated () {
        let ticket = this.scannedTicket.ticketState
        var ticketStatus
        switch (ticket) {
          case 'O':
            ticketStatus = 'Open'
            break
          case 'C':
            ticketStatus = 'Closed'
            break
          case 'F':
            ticketStatus = 'Failed'
            break
          case 'U':
            ticketStatus = 'Unpaid'
            break
          case 'l':
            ticketStatus = 'Loser'
            break
          case 'c':
            ticketStatus = 'Claimed'
            break
          case 'e':
            ticketStatus = 'Expired'
            break
          case 'x':
            ticketStatus = 'Canceled'
            break
          case 'b':
            ticketStatus = 'Blocked'
            break
          case 'N':
            ticketStatus = 'Undetermined'
            break
          default:
            ticketStatus = ''
        }
        return ticketStatus
      },
      payoutAmountFormated () {
        return this.scannedTicket.payoutAmount ? this.scannedTicket.payoutAmount.toLocaleString('en-US') : this.scannedTicket.payoutAmount
      }
    },

    methods: {
      closeDialog () {
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
      },
      closeBarCodeDialog () {
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
        if (this.$route.name !== 'savedbets') {
          this.$router.push({name: 'savedbets'})
        }
        store.dispatch('overlayState/deactivateBetslip')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      deleteWishBet () {
        // console.log('deleteWishBet')
        store.dispatch('wishBets/deleteWishBet', this.wishBetMsg.data.content)
        store.dispatch('overlayState/deactivateWishBetMsgDialog', {active: false, data: ''})
      }
    },

    created () {

    },

    watch: {

    },

    destroyed () {
    }
  }
</script>

<style lang="stylus" scoped>
.dialog_header
  display flex
  justify-content: space-between
  padding-bottom 40px
  align-items center
  h3 
    text-align center
    flex-grow 1
    margin 0
    font-size 20px
  .header_text
    text-align left
    font-size 14px
    font-family 'Open Sans SemiBold'
    padding-right 10px
  .v-icon
    color #003764
    font-size 35px
    margin-right -10px
    margin-bottom auto
.dialog_text p
  font-size 14px
  font-family 'Open Sans SemiBold'
  padding 10px 0
.error_msg
  padding-bottom 20px
  font-size 14px
.ticket_info
  padding: 20px 0
  text-align left
  font-size 14px
  .line
    display block
    padding 1px 0
    .label
      font-family 'Open Sans SemiBold'
.payout_amount
  margin 0
  padding 20px 0 0 0
  .amount
    font-size 16px
    padding-left 5px
.ticket_desc
  padding 10px 0 0 0
  font-size 14px
.ticket_status
  padding 10px 40px
  font-size 20px
  width auto
  display block
  color #fff
  &.Unpaid
  &.Win
    background #1fc600
  &.Open
    background #ff9900
  &.Lost
  &.Loser
    background #2a77aa
  &.Failed
  &.Undetermined
  &.Closed
  &.Blocked
  &.Canceled
  &.Paid
  &.Expired
  &.Claimed
    background #8db5d4
</style>



// WEBPACK FOOTER //
// src/components/common/wishBetMsgDialog.vue